import { createAction, props } from '@ngrx/store';
import { Institution } from 'src/generated/graphql';
import { InstitutionInCompare } from '../../models/institution-in-compare';

export const addToCompare = createAction(
  '[Compare] add to compare',
  props<{ institution: Institution }>()
);

export const addToCompareSuccess = createAction(
  '[Compare] add to compare success',
  props<{ institution: Institution }>()
);

export const addToCompareFailure = createAction(
  '[Compare] add to compare failure',
  props<{ message: string }>()
);

export const removeFromCompare = createAction(
  '[Compare] remove from compare',
  props<{ institution: Institution }>()
);

export const sendEmail = createAction('[Compare] send email', props<{ body: FormData }>());

export const sendEmailSuccess = createAction(
  '[Compare] send email success',
  props<{ data: any }>()
);

export const sendEmailFailure = createAction(
  '[Compare] send email failure',
  props<{ message: string }>()
);

export const getInstitutionsInCompare = createAction('[Compare] get institutions in compare');

export const getInstitutionsInCompareSuccess = createAction(
  '[Compare] get institutions in compare success',
  props<{ institutions: InstitutionInCompare[] }>()
);

export const getInstitutionsInCompareFailure = createAction(
  '[Compare] get institutions in compare failure',
  props<{ message: string }>()
);
